import { UserService } from '@/common/api/api.service'

export const actionButtonStateInfoData = async (contentType, contentInfo) => {
  const getContentIdType = (type) => {
    switch (type) {
      case 'vod':
      case 'qvod':
        return contentInfo?.contentid ?? ''
      case 'live':
        return contentInfo?.channelid ?? ''
      case 'movie':
        return contentInfo?.movieid ?? ''
      default:
        return ''
    }
  }

  const contentId = getContentIdType(contentType)

  const premissionRes = await UserService.getPermissionForContent({
    contentId,
    contentType,
  })

  return {
    isVisible: false,
    title: premissionRes?.data?.display ?? '',
    action: premissionRes?.data?.action ?? '',
  }
}
